var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixelChoppingSalad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 229,
    viewBox: "0 0 205 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1701_103)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.608 136.94L149.287 142.245L142.827 142.785L145.608 136.94Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.93 131.636L145.608 136.941L139.148 137.48L141.93 131.636Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.252 126.331L141.93 131.636L135.471 132.176L138.252 126.331Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8447 52.0615L90.523 57.3665L84.0635 57.906L86.8447 52.0615Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.166 46.7559L86.8443 52.0608L80.3848 52.6003L83.166 46.7559Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4882 41.4512L83.1666 46.7561L76.707 47.2956L79.4882 41.4512Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.505 148.09L142.827 142.785L149.287 142.245L146.505 148.09Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.827 142.785L139.148 137.48L145.608 136.94L142.827 142.785Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.149 137.48L135.471 132.175L141.93 131.636L139.149 137.48Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.47 132.176L131.792 126.871L138.252 126.331L135.47 132.176Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7418 63.2107L84.0635 57.9057L90.523 57.3662L87.7418 63.2107Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0631 57.906L80.3848 52.601L86.8443 52.0615L84.0631 57.906Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3854 52.6003L76.707 47.2954L83.1666 46.7559L80.3854 52.6003Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7067 47.2956L73.0283 41.9907L79.4878 41.4512L76.7067 47.2956Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.725 153.934L147.403 159.239L150.184 153.395L143.725 153.934Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.046 148.629L143.724 153.934L146.505 148.09L140.046 148.629Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.367 143.325L140.046 148.63L142.827 142.785L136.367 143.325Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.689 138.02L136.368 143.325L139.149 137.48L132.689 138.02Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.011 132.714L132.689 138.019L135.47 132.175L129.011 132.714Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.333 127.41L129.011 132.715L131.793 126.87L125.333 127.41Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.654 122.105L125.333 127.41L128.114 121.565L121.654 122.105Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.976 116.799L121.654 122.104L124.435 116.26L117.976 116.799Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.298 111.495L117.976 116.8L120.757 110.955L114.298 111.495Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.619 106.19L114.297 111.495L117.079 105.65L110.619 106.19Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.941 100.975L110.62 106.28L113.401 100.436L106.941 100.975Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.263 95.6694L106.941 100.974L109.722 95.1299L103.263 95.6694Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.584 90.3647L103.262 95.6697L106.043 89.8252L99.584 90.3647Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9062 85.06L99.5846 90.365L102.366 84.5205L95.9062 85.06Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3174 79.7553L95.9957 85.0603L98.7769 79.2158L92.3174 79.7553Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6387 74.4496L92.317 79.7546L95.0982 73.9102L88.6387 74.4496Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9609 69.145L88.6393 74.4499L91.4204 68.6055L84.9609 69.145Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2822 63.8403L84.9606 69.1452L87.7417 63.3008L81.2822 63.8403Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6035 58.5346L81.2819 63.8396L84.063 57.9951L77.6035 58.5346Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9258 53.2299L77.6041 58.5349L80.3853 52.6904L73.9258 53.2299Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2471 47.9252L73.9254 53.2302L76.7066 47.3857L70.2471 47.9252Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5693 42.6205L70.2477 47.9255L73.0289 42.0811L66.5693 42.6205Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.184 153.395L146.506 148.09L143.725 153.934L150.184 153.395Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.505 148.09L142.827 142.785L140.046 148.63L146.505 148.09Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.827 142.785L139.148 137.48L136.367 143.325L142.827 142.785Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.149 137.48L135.471 132.175L132.689 138.019L139.149 137.48Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.47 132.175L131.792 126.87L129.011 132.715L135.47 132.175Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.793 126.87L128.114 121.565L125.333 127.41L131.793 126.87Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.114 121.565L124.435 116.26L121.654 122.104L128.114 121.565Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.435 116.26L120.757 110.955L117.976 116.8L124.435 116.26Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.757 110.955L117.079 105.65L114.298 111.495L120.757 110.955Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.079 105.651L113.4 100.346L110.619 106.19L117.079 105.651Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.401 100.345L109.723 95.04L106.941 100.885L113.401 100.345Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.722 95.0403L106.044 89.7354L103.263 95.5798L109.722 95.0403Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.043 89.7356L102.365 84.4307L99.584 90.2751L106.043 89.7356Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.456 84.43L98.7773 79.125L95.9961 84.9695L102.456 84.43Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7769 79.1253L95.0986 73.8203L92.3174 79.6648L98.7769 79.1253Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0982 73.8206L91.4198 68.5156L88.6387 74.3601L95.0982 73.8206Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4204 68.5159L87.7421 63.2109L84.9609 69.0554L91.4204 68.5159Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7417 63.2102L84.0634 57.9053L81.2822 63.7497L87.7417 63.2102Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.063 57.9056L80.3847 52.6006L77.6035 58.445L84.063 57.9056Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3853 52.6009L76.707 47.2959L73.9258 53.1404L80.3853 52.6009Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7066 47.2952L73.0283 41.9902L70.2471 47.8347L76.7066 47.2952Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.635 153.935L147.313 159.24L140.854 159.779L143.635 153.935Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.046 148.63L143.724 153.935L137.265 154.474L140.046 148.63Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.367 143.324L140.045 148.629L133.586 149.169L136.367 143.324Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.689 138.02L136.368 143.324L129.908 143.864L132.689 138.02Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.011 132.715L132.689 138.02L126.229 138.559L129.011 132.715Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.333 127.409L129.011 132.714L122.552 133.254L125.333 127.409Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.654 122.104L125.333 127.409L118.873 127.949L121.654 122.104Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.976 116.8L121.654 122.105L115.194 122.644L117.976 116.8Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.298 111.585L117.976 116.89L111.517 117.429L114.298 111.585Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.619 106.279L114.297 111.584L107.838 112.124L110.619 106.279Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.941 100.975L110.62 106.28L104.16 106.819L106.941 100.975Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.263 95.6699L106.941 100.975L100.481 101.514L103.263 95.6699Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5839 90.3652L103.262 95.6702L96.8027 96.2097L99.5839 90.3652Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9062 85.0596L99.5845 90.3645L93.125 90.904L95.9062 85.0596Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2275 79.7549L95.9058 85.0599L89.4463 85.5993L92.2275 79.7549Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6386 74.4502L92.3169 79.7552L85.8574 80.2947L88.6386 74.4502Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9609 69.1445L88.6392 74.4495L82.1797 74.989L84.9609 69.1445Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2822 63.8398L84.9605 69.1448L78.501 69.6843L81.2822 63.8398Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6034 58.5352L81.2818 63.8401L74.8223 64.3796L77.6034 58.5352Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9257 53.2305L77.604 58.5354L71.1445 59.0749L73.9257 53.2305Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.247 47.9248L73.9253 53.2298L67.4658 53.7693L70.247 47.9248Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5693 42.6201L70.2476 47.9251L63.7881 48.4646L66.5693 42.6201Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.853 159.869L137.175 154.564L143.634 154.024L140.853 159.869Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.175 154.564L133.497 149.259L139.957 148.72L137.175 154.564Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.587 149.259L129.908 143.954L136.368 143.414L133.587 149.259Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.908 143.954L126.229 138.649L132.689 138.109L129.908 143.954Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.23 138.649L122.552 133.344L129.011 132.805L126.23 138.649Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.551 133.344L118.873 128.039L125.333 127.5L122.551 133.344Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.873 128.039L115.194 122.734L121.654 122.194L118.873 128.039Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.195 122.734L111.517 117.429L117.976 116.89L115.195 122.734Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.516 117.429L107.838 112.124L114.297 111.585L111.516 117.429Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.839 112.124L104.16 106.819L110.62 106.279L107.839 112.124Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.16 106.819L100.481 101.514L106.941 100.975L104.16 106.819Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.481 101.514L96.8027 96.2094L103.262 95.6699L100.481 101.514Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8033 96.2097L93.125 90.9047L99.5845 90.3652L96.8033 96.2097Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1246 90.904L89.4463 85.5991L95.9058 85.0596L93.1246 90.904Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4459 85.5993L85.7676 80.2944L92.2271 79.7549L89.4459 85.5993Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7682 80.2947L82.0898 74.9897L88.5494 74.4502L85.7682 80.2947Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1793 74.989L78.501 69.684L84.9605 69.1445L82.1793 74.989Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5006 69.6843L74.8223 64.3793L81.2818 63.8398L78.5006 69.6843Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8229 64.3796L71.1445 59.0746L77.604 58.5352L74.8229 64.3796Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1442 59.0749L67.4658 53.77L73.9253 53.2305L71.1442 59.0749Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4664 53.7693L63.7881 48.4643L70.2476 47.9248L67.4664 53.7693Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.716 155.103L134.394 160.408L137.175 154.563L130.716 155.103Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.037 149.798L130.715 155.103L133.497 149.259L127.037 149.798Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.448 144.494L127.127 149.799L129.908 143.954L123.448 144.494Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.771 139.189L123.449 144.494L126.23 138.649L119.771 139.189Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.092 133.883L119.77 139.188L122.551 133.344L116.092 133.883Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.413 128.579L116.091 133.884L118.873 128.039L112.413 128.579Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.735 123.274L112.414 128.579L115.195 122.734L108.735 123.274Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.057 117.968L108.735 123.273L111.516 117.429L105.057 117.968Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.379 112.664L105.057 117.968L107.838 112.124L101.379 112.664Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7002 107.359L101.379 112.664L104.16 106.819L97.7002 107.359Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0215 102.054L97.6998 107.359L100.481 101.515L94.0215 102.054Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3438 96.7485L94.0221 102.053L96.8033 96.209L90.3438 96.7485Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.665 91.4438L90.3434 96.7488L93.1246 90.9043L86.665 91.4438Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9873 86.1391L86.6656 91.4441L89.4468 85.5996L82.9873 86.1391Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3086 80.8334L82.9869 86.1384L85.7681 80.2939L79.3086 80.8334Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7197 75.5287L79.3981 80.8337L82.1792 74.9893L75.7197 75.5287Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.042 70.2241L75.7203 75.529L78.5015 69.6846L72.042 70.2241Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3633 64.9194L72.0416 70.2243L74.8228 64.3799L68.3633 64.9194Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6846 59.6137L68.3629 64.9187L71.1441 59.0742L64.6846 59.6137Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0068 54.309L64.6852 59.614L67.4664 53.7695L61.0068 54.309Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.853 159.868L137.175 154.563L134.394 160.408L140.853 159.868Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.175 154.564L133.497 149.259L130.716 155.103L137.175 154.564Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.586 149.259L129.908 143.954L127.127 149.799L133.586 149.259Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.908 143.954L126.229 138.649L123.448 144.494L129.908 143.954Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.23 138.649L122.552 133.344L119.771 139.188L126.23 138.649Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.551 133.344L118.873 128.039L116.092 133.884L122.551 133.344Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.873 128.039L115.194 122.734L112.413 128.579L118.873 128.039Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.195 122.734L111.517 117.429L108.735 123.273L115.195 122.734Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.516 117.429L107.838 112.124L105.057 117.968L111.516 117.429Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.838 112.124L104.16 106.819L101.379 112.664L107.838 112.124Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.16 106.82L100.481 101.515L97.7002 107.359L104.16 106.82Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.481 101.514L96.8027 96.209L94.0215 102.053L100.481 101.514Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8033 96.2093L93.1249 90.9043L90.3438 96.7488L96.8033 96.2093Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1246 90.9046L89.4462 85.5996L86.665 91.4441L93.1246 90.9046Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4468 85.5989L85.7685 80.2939L82.9873 86.1384L89.4468 85.5989Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7681 80.2942L82.0898 74.9893L79.3086 80.8337L85.7681 80.2942Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1792 74.9895L78.5009 69.6846L75.7197 75.529L82.1792 74.9895Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5015 69.6849L74.8232 64.3799L72.042 70.2243L78.5015 69.6849Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8228 64.3792L71.1445 59.0742L68.3633 64.9187L74.8228 64.3792Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1441 59.0745L67.4658 53.7695L64.6846 59.614L71.1441 59.0745Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4664 53.7698L63.788 48.4648L61.0068 54.3093L67.4664 53.7698Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.716 155.104L134.394 160.408L127.935 160.948L130.716 155.104Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.037 149.799L130.715 155.104L124.256 155.643L127.037 149.799Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.359 144.493L127.038 149.798L120.578 150.338L123.359 144.493Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.77 139.188L123.449 144.493L116.989 145.033L119.77 139.188Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.092 133.884L119.77 139.189L113.311 139.728L116.092 133.884Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.414 128.578L116.092 133.883L109.633 134.423L112.414 128.578Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.735 123.273L112.414 128.578L105.954 129.118L108.735 123.273Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.057 117.969L108.735 123.274L102.275 123.813L105.057 117.969Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.379 112.664L105.057 117.969L98.5977 118.509L101.379 112.664Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7001 107.358L101.378 112.663L94.9189 113.203L97.7001 107.358Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0214 102.054L97.6998 107.359L91.2402 107.898L94.0214 102.054Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3437 96.749L94.022 102.054L87.5625 102.593L90.3437 96.749Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.665 91.4434L90.3433 96.7483L83.8838 97.2878L86.665 91.4434Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9872 86.1387L86.6656 91.4436L80.2061 91.9831L82.9872 86.1387Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3085 80.834L82.9869 86.139L76.5273 86.6784L79.3085 80.834Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6298 75.5293L79.3082 80.8343L72.8486 81.3738L75.6298 75.5293Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0419 70.2236L75.7203 75.5286L69.2607 76.0681L72.0419 70.2236Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3632 64.9189L72.0415 70.2239L65.582 70.7634L68.3632 64.9189Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6845 59.6143L68.3628 64.9192L61.9033 65.4587L64.6845 59.6143Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0068 54.3086L64.6851 59.6136L58.2256 60.1531L61.0068 54.3086Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.934 160.948L124.256 155.643L130.715 155.104L127.934 160.948Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.256 155.643L120.578 150.338L127.038 149.799L124.256 155.643Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.578 150.338L116.899 145.033L123.359 144.493L120.578 150.338Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.899 145.033L113.221 139.728L119.68 139.188L116.899 145.033Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.311 139.728L109.633 134.423L116.092 133.884L113.311 139.728Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.632 134.423L105.954 129.118L112.414 128.578L109.632 134.423Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.954 129.118L102.275 123.813L108.735 123.273L105.954 129.118Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.276 123.813L98.5977 118.508L105.057 117.969L102.276 123.813Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5973 118.509L94.9189 113.204L101.378 112.664L98.5973 118.509Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9186 113.203L91.2402 107.898L97.6998 107.358L94.9186 113.203Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2408 107.898L87.5625 102.593L94.022 102.054L91.2408 107.898Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5621 102.593L83.8838 97.2885L90.3433 96.749L87.5621 102.593Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8844 97.3777L80.2061 92.0727L86.6656 91.5332L83.8844 97.3777Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2057 92.073L76.5273 86.768L82.9869 86.2285L80.2057 92.073Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.527 86.7683L72.8486 81.4633L79.3082 80.9238L76.527 86.7683Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8492 81.4636L69.1709 76.1586L75.6304 75.6191L72.8492 81.4636Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1705 76.1579L65.4922 70.853L71.9517 70.3135L69.1705 76.1579Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4928 70.8532L61.8145 65.5483L68.274 65.0088L65.4928 70.8532Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9039 65.5486L58.2256 60.2436L64.6851 59.7041L61.9039 65.5486Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.439 145.663L114.118 150.968L116.899 145.123L110.439 145.663Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.762 140.358L110.44 145.663L113.221 139.818L106.762 140.358Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.173 135.052L106.851 140.357L109.632 134.513L103.173 135.052Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4941 129.747L103.172 135.052L105.954 129.208L99.4941 129.747Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8164 124.443L99.4947 129.748L102.276 123.903L95.8164 124.443Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1377 119.137L95.816 124.442L98.5972 118.598L92.1377 119.137Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.46 113.832L92.1383 119.137L94.9195 113.293L88.46 113.832Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7812 108.528L88.4596 113.833L91.2408 107.988L84.7812 108.528Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1025 103.222L84.7809 108.527L87.5621 102.683L81.1025 103.222Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4248 97.9174L81.1031 103.222L83.8843 97.3779L77.4248 97.9174Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7461 92.6127L77.4244 97.9177L80.2056 92.0732L73.7461 92.6127Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0674 87.308L73.7457 92.613L76.5269 86.7686L70.0674 87.308Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3896 82.0024L70.068 87.3073L72.8492 81.4629L66.3896 82.0024Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7109 76.6977L66.3893 82.0027L69.1705 76.1582L62.7109 76.6977Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0332 71.393L62.7115 76.698L65.4927 70.8535L59.0332 71.393Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.578 150.338L116.899 145.033L114.118 150.878L120.578 150.338Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.899 145.033L113.221 139.728L110.439 145.572L116.899 145.033Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.311 139.728L109.633 134.423L106.852 140.267L113.311 139.728Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.632 134.423L105.954 129.118L103.173 134.963L109.632 134.423Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.954 129.118L102.275 123.813L99.4941 129.658L105.954 129.118Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.276 123.813L98.5976 118.508L95.8164 124.352L102.276 123.813Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5972 118.508L94.9189 113.203L92.1377 119.048L98.5972 118.508Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9195 113.203L91.2411 107.898L88.46 113.743L94.9195 113.203Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.2408 107.898L87.5624 102.593L84.7812 108.437L91.2408 107.898Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5621 102.593L83.8837 97.2881L81.1025 103.133L87.5621 102.593Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8843 97.3782L80.206 92.0732L77.4248 97.9177L83.8843 97.3782Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2056 92.0735L76.5273 86.7686L73.7461 92.613L80.2056 92.0735Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5269 86.7679L72.8486 81.4629L70.0674 87.3073L76.5269 86.7679Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8492 81.4632L69.1708 76.1582L66.3896 82.0027L72.8492 81.4632Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1705 76.1585L65.4921 70.8535L62.7109 76.698L69.1705 76.1585Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4927 70.8528L61.8144 65.5479L59.0332 71.3923L65.4927 70.8528Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4941 129.747L103.172 135.052L96.7129 135.592L99.4941 129.747Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8163 124.442L99.4947 129.747L93.0352 130.287L95.8163 124.442Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1376 119.138L95.816 124.443L89.3564 124.982L92.1376 119.138Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4599 113.832L92.1382 119.137L85.6787 119.676L88.4599 113.832Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7812 108.527L88.4595 113.832L82 114.372L84.7812 108.527Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1025 103.223L84.7808 108.528L78.3213 109.067L81.1025 103.223Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4247 97.918L81.1031 103.223L74.6436 103.762L77.4247 97.918Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.746 92.6123L77.4244 97.9173L70.9648 98.4568L73.746 92.6123Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0683 87.3076L73.7466 92.6126L67.2871 93.1521L70.0683 87.3076Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3896 82.0029L70.0679 87.3079L63.6084 87.8474L66.3896 82.0029Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7109 76.6973L66.3892 82.0022L59.9297 82.5417L62.7109 76.6973Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6237 135.592L92.9453 130.287L99.4048 129.747L96.6237 135.592Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0348 130.287L89.3564 124.982L95.816 124.442L93.0348 130.287Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.357 124.982L85.6787 119.677L92.1382 119.138L89.357 124.982Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6783 119.676L82 114.372L88.4595 113.832L85.6783 119.676Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9996 114.372L78.3213 109.067L84.7808 108.527L81.9996 114.372Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3219 109.067L74.6436 103.762L81.1031 103.223L78.3219 109.067Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6432 103.762L70.9648 98.4575L77.4244 97.918L74.6432 103.762Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9654 98.4568L67.2871 93.1518L73.7466 92.6123L70.9654 98.4568Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2867 93.1521L63.6084 87.8471L70.0679 87.3076L67.2867 93.1521Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.608 87.8474L59.9297 82.5424L66.3892 82.0029L63.608 87.8474Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8622 109.606L75.5406 114.911L69.0811 115.451L71.8622 109.606Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1835 104.302L71.8619 109.607L65.4023 110.146L68.1835 104.302Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5058 98.9971L68.1841 104.302L61.7246 104.842L64.5058 98.9971Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8271 93.7812L64.5054 99.0862L58.0459 99.6257L60.8271 93.7812Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1484 88.4766L60.8267 93.7815L54.3672 94.321L57.1484 88.4766Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4706 83.1719L57.149 88.4768L50.6895 89.0163L53.4706 83.1719Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7919 77.8662L53.4703 83.1712L47.0107 83.7107L49.7919 77.8662Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1142 72.5615L49.7925 77.8665L43.333 78.406L46.1142 72.5615Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4355 67.2568L46.1138 72.5618L39.6543 73.1013L42.4355 67.2568Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7594 120.845L69.0811 115.54L75.5406 115.001L72.7594 120.845Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0807 115.541L65.4023 110.236L71.8619 109.696L69.0807 115.541Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4029 110.236L61.7246 104.931L68.1841 104.392L65.4029 110.236Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7242 104.931L58.0459 99.6264L64.5054 99.0869L61.7242 104.931Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0455 99.6257L54.3672 94.3207L60.8267 93.7812L58.0455 99.6257Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3678 94.321L50.6895 89.016L57.149 88.4766L54.3678 94.321Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6891 89.0163L47.0107 83.7114L53.4703 83.1719L50.6891 89.0163Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0113 83.7107L43.333 78.4057L49.7925 77.8662L47.0113 83.7107Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3326 78.406L39.6543 73.101L46.1138 72.5615L43.3326 78.406Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6539 73.1013L35.9756 67.7963L42.4351 67.2568L39.6539 73.1013Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5664 131.996L77.2447 137.301L80.0259 131.456L73.5664 131.996Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8887 126.69L73.567 131.995L76.3482 126.15L69.8887 126.69Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.21 121.385L69.8883 126.69L72.6695 120.846L66.21 121.385Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6211 116.08L66.2994 121.385L69.0806 115.541L62.6211 116.08Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9434 110.776L62.6217 116.081L65.4029 110.236L58.9434 110.776Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2646 105.47L58.943 110.775L61.7242 104.931L55.2646 105.47Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5869 100.165L55.2652 105.47L58.0464 99.626L51.5869 100.165Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9082 94.8608L51.5865 100.166L54.3677 94.3213L47.9082 94.8608Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2295 89.5551L47.9078 94.8601L50.689 89.0156L44.2295 89.5551Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5518 84.2504L44.2301 89.5554L47.0113 83.7109L40.5518 84.2504Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.873 78.9457L40.5514 84.2507L43.3326 78.4062L36.873 78.9457Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1943 73.641L36.8727 78.946L39.6539 73.1016L33.1943 73.641Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5166 68.3354L33.1949 73.6404L35.9761 67.7959L29.5166 68.3354Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8379 63.0307L29.5162 68.3357L32.2974 62.4912L25.8379 63.0307Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1602 57.726L25.8385 63.031L28.6197 57.1865L22.1602 57.726Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0259 131.455L76.3476 126.15L73.5664 131.995L80.0259 131.455Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3482 126.151L72.6699 120.846L69.8887 126.69L76.3482 126.151Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7593 120.846L69.081 115.541L66.2998 121.385L72.7593 120.846Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0806 115.541L65.4023 110.236L62.6211 116.081L69.0806 115.541Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4029 110.236L61.7245 104.931L58.9434 110.775L65.4029 110.236Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7242 104.931L58.0458 99.626L55.2646 105.47L61.7242 104.931Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0464 99.6263L54.3681 94.3213L51.5869 100.166L58.0464 99.6263Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3677 94.3206L50.6894 89.0156L47.9082 94.8601L54.3677 94.3206Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.689 89.0159L47.0107 83.7109L44.2295 89.5554L50.689 89.0159Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0113 83.7112L43.3329 78.4062L40.5518 84.2507L47.0113 83.7112Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3326 78.4065L39.6542 73.1016L36.873 78.946L43.3326 78.4065Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6539 73.1009L35.9755 67.7959L33.1943 73.6404L39.6539 73.1009Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9761 67.7962L32.2978 62.4912L29.5166 68.3357L35.9761 67.7962Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2974 62.4915L28.6191 57.1865L25.8379 63.031L32.2974 62.4915Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.245 137.3L80.9234 142.605L74.4639 143.144L77.245 137.3Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5663 131.995L77.2447 137.3L70.7852 137.84L73.5663 131.995Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8886 126.69L73.5669 131.995L67.1074 132.535L69.8886 126.69Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2099 121.386L69.8882 126.691L63.4287 127.23L66.2099 121.386Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5322 116.08L66.2105 121.385L59.751 121.925L62.5322 116.08Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9433 110.775L62.6216 116.08L56.1621 116.62L58.9433 110.775Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2646 105.471L58.9429 110.776L52.4834 111.315L55.2646 105.471Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5868 100.165L55.2652 105.47L48.8057 106.009L51.5868 100.165Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9081 94.8604L51.5865 100.165L45.127 100.705L47.9081 94.8604Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2294 89.5557L47.9078 94.8606L41.4482 95.4001L44.2294 89.5557Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5517 84.251L44.23 89.5559L37.7705 90.0954L40.5517 84.251Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.873 78.9453L40.5513 84.2503L34.0918 84.7898L36.873 78.9453Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1943 73.6406L36.8726 78.9456L30.4131 79.4851L33.1943 73.6406Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5165 68.3359L33.1949 73.6409L26.7354 74.1804L29.5165 68.3359Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8378 63.0303L29.5162 68.3352L23.0566 68.8747L25.8378 63.0303Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1601 57.7256L25.8384 63.0306L19.3789 63.57L22.1601 57.7256Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4814 52.4209L22.1597 57.7259L15.7002 58.2654L18.4814 52.4209Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1422 148.45L74.4639 143.145L80.9234 142.605L78.1422 148.45Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4635 143.144L70.7852 137.839L77.2447 137.3L74.4635 143.144Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7858 137.84L67.1074 132.535L73.5669 131.995L70.7858 137.84Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.107 132.535L63.4287 127.23L69.8882 126.69L67.107 132.535Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4293 127.23L59.751 121.925L66.2105 121.386L63.4293 127.23Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7506 121.925L56.0723 116.62L62.5318 116.08L59.7506 121.925Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0719 116.62L52.3936 111.315L58.8531 110.775L56.0719 116.62Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.484 111.315L48.8057 106.01L55.2652 105.471L52.484 111.315Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8053 106.009L45.127 100.705L51.5865 100.165L48.8053 106.009Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1266 100.705L41.4482 95.3998L47.9078 94.8604L45.1266 100.705Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4488 95.4001L37.7705 90.0952L44.23 89.5557L41.4488 95.4001Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7701 90.0954L34.0918 84.7905L40.5513 84.251L37.7701 90.0954Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0914 84.7898L30.4131 79.4848L36.8726 78.9453L34.0914 84.7898Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4137 79.5749L26.7354 74.27L33.1949 73.7305L30.4137 79.5749Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.735 74.2702L23.0566 68.9653L29.5162 68.4258L26.735 74.2702Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0572 68.9656L19.3789 63.6606L25.8384 63.1211L23.0572 68.9656Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3785 63.6599L15.7002 58.3549L22.1597 57.8154L19.3785 63.6599Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6998 58.3552L12.0215 53.0502L18.481 52.5107L15.6998 58.3552Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3613 154.384L79.0397 159.689L81.8208 153.845L75.3613 154.384Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6826 149.08L75.361 154.384L78.1421 148.54L71.6826 149.08Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0039 143.774L71.6822 149.079L74.4634 143.234L68.0039 143.774Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3262 138.469L68.0045 143.774L70.7857 137.93L64.3262 138.469Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6475 133.164L64.3258 138.469L67.107 132.625L60.6475 133.164Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9697 127.859L60.6481 133.164L63.4292 127.319L56.9697 127.859Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.291 122.554L56.9694 127.859L59.7505 122.015L53.291 122.554Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6123 117.249L53.2906 122.554L56.0718 116.71L49.6123 117.249Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0244 111.945L49.7027 117.25L52.4839 111.405L46.0244 111.945Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3457 106.639L46.024 111.944L48.8052 106.1L42.3457 106.639Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.667 101.334L42.3453 106.639L45.1265 100.795L38.667 101.334Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9893 96.0297L38.6676 101.335L41.4488 95.4902L34.9893 96.0297Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3105 90.7241L34.9889 96.029L37.7701 90.1846L31.3105 90.7241Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6328 85.4194L31.3112 90.7243L34.0923 84.8799L27.6328 85.4194Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9541 80.1147L27.6324 85.4196L30.4136 79.5752L23.9541 80.1147Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2754 74.81L23.9537 80.115L26.7349 74.2705L20.2754 74.81Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5977 69.5043L20.276 74.8093L23.0572 68.9648L16.5977 69.5043Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9189 64.1996L16.5973 69.5046L19.3785 63.6602L12.9189 64.1996Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24023 58.895L12.9186 64.1999L15.6998 58.3555L9.24023 58.895Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5625 53.5893L9.24084 58.8943L12.022 53.0498L5.5625 53.5893Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8208 153.754L78.1425 148.449L75.3613 154.294L81.8208 153.754Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1421 148.45L74.4638 143.145L71.6826 148.989L78.1421 148.45Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4634 143.145L70.7851 137.84L68.0039 143.684L74.4634 143.145Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7857 137.84L67.1074 132.535L64.3262 138.38L70.7857 137.84Z",
    fill: "#B8D351"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.107 132.534L63.4286 127.229L60.6475 133.074L67.107 132.534Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4292 127.23L59.7509 121.925L56.9697 127.769L63.4292 127.23Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7505 121.925L56.0722 116.62L53.291 122.465L59.7505 121.925Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0718 116.619L52.3935 111.314L49.6123 117.159L56.0718 116.619Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4839 111.315L48.8056 106.01L46.0244 111.854L52.4839 111.315Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8052 106.01L45.1269 100.705L42.3457 106.55L48.8052 106.01Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1265 100.705L41.4482 95.4004L38.667 101.245L45.1265 100.705Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4488 95.3997L37.7704 90.0947L34.9893 95.9392L41.4488 95.3997Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7701 90.095L34.0917 84.79L31.3105 90.6345L37.7701 90.095Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0923 84.7903L30.414 79.4854L27.6328 85.3298L34.0923 84.7903Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4136 79.5755L26.7353 74.2705L23.9541 80.115L30.4136 79.5755Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7349 74.2698L23.0566 68.9648L20.2754 74.8093L26.7349 74.2698Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0572 68.9651L19.3788 63.6602L16.5977 69.5046L23.0572 68.9651Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3785 63.6604L15.7001 58.3555L12.9189 64.1999L19.3785 63.6604Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6998 58.3548L12.0214 53.0498L9.24023 58.8943L15.6998 58.3548Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3613 154.384L79.0396 159.689L72.5801 160.228L75.3613 154.384Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6825 149.079L75.3609 154.384L68.9014 154.924L71.6825 149.079Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0048 143.774L71.6831 149.079L65.2236 149.619L68.0048 143.774Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3261 138.469L68.0044 143.774L61.5449 144.313L64.3261 138.469Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6474 133.164L64.3257 138.469L57.8662 139.009L60.6474 133.164Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9697 127.859L60.648 133.164L54.1885 133.704L56.9697 127.859Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2909 122.555L56.9693 127.86L50.5098 128.399L53.2909 122.555Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6122 117.249L53.2906 122.554L46.8311 123.093L49.6122 117.249Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9345 111.944L49.6128 117.249L43.1533 117.789L45.9345 111.944Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2558 106.64L45.9341 111.945L39.4746 112.484L42.2558 106.64Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6669 101.334L42.3453 106.639L35.8857 107.178L38.6669 101.334Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9892 96.0293L38.6675 101.334L32.208 101.874L34.9892 96.0293Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3105 90.7246L34.9888 96.0296L28.5293 96.5691L31.3105 90.7246Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6327 85.4199L31.3111 90.7249L24.8516 91.2644L27.6327 85.4199Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.954 80.1143L27.6324 85.4192L21.1729 85.9587L23.954 80.1143Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2753 74.8096L23.9537 80.1145L17.4941 80.654L20.2753 74.8096Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5976 69.5049L20.2759 74.8098L13.8164 75.3493L16.5976 69.5049Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9189 64.1992L16.5972 69.5042L10.1377 70.0437L12.9189 64.1992Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24114 58.8945L12.9195 64.1995L6.45996 64.739L9.24114 58.8945Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56243 53.5898L9.24077 58.8948L2.78125 59.4343L5.56243 53.5898Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2584 165.534L72.5801 160.229L79.0396 159.689L76.2584 165.534Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5797 160.228L68.9014 154.923L75.3609 154.384L72.5797 160.228Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.902 154.924L65.2236 149.619L71.6831 149.079L68.902 154.924Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2233 149.619L61.5449 144.314L68.0044 143.774L65.2233 149.619Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5446 144.313L57.8662 139.008L64.3257 138.469L61.5446 144.313Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8668 139.009L54.1885 133.704L60.648 133.164L57.8668 139.009Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1881 133.704L50.5098 128.399L56.9693 127.859L54.1881 133.704Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5094 128.399L46.8311 123.094L53.2906 122.555L50.5094 128.399Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8317 123.093L43.1533 117.789L49.6128 117.249L46.8317 123.093Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1529 117.789L39.4746 112.484L45.9341 111.944L43.1529 117.789Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4752 112.484L35.7969 107.179L42.2564 106.64L39.4752 112.484Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7965 107.178L32.1182 101.873L38.5777 101.334L35.7965 107.178Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2076 101.874L28.5293 96.5688L34.9888 96.0293L32.2076 101.874Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5299 96.5691L24.8516 91.2641L31.3111 90.7246L28.5299 96.5691Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8512 91.2644L21.1729 85.9594L27.6324 85.4199L24.8512 91.2644Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1725 85.9587L17.4941 80.6537L23.9537 80.1143L21.1725 85.9587Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4947 80.654L13.8164 75.3491L20.2759 74.8096L17.4947 80.654Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.816 75.3493L10.1377 70.0444L16.5972 69.5049L13.816 75.3493Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1383 70.0437L6.45996 64.7387L12.9195 64.1992L10.1383 70.0437Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45959 64.739L2.78125 59.434L9.24077 58.8945L6.45959 64.739Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1201 160.768L69.7985 166.073L72.5796 160.229L66.1201 160.768Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4424 155.463L66.1207 160.768L68.9019 154.924L62.4424 155.463Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7637 150.158L62.442 155.463L65.2232 149.618L58.7637 150.158Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.085 144.853L58.7633 150.158L61.5445 144.313L55.085 144.853Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4072 139.548L55.0856 144.853L57.8667 139.009L51.4072 139.548Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7285 134.244L51.4069 139.549L54.188 133.704L47.7285 134.244Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0508 128.938L47.7291 134.243L50.5103 128.398L44.0508 128.938Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3721 123.633L44.0504 128.938L46.8316 123.094L40.3721 123.633Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6934 118.329L40.3717 123.634L43.1529 117.789L36.6934 118.329Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0156 113.023L36.694 118.328L39.4751 112.483L33.0156 113.023Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3369 107.718L33.0153 113.023L35.7964 107.179L29.3369 107.718Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.748 102.414L29.4264 107.718L32.2076 101.874L25.748 102.414Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0703 97.1088L25.7486 102.414L28.5298 96.5693L22.0703 97.1088Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35645 75.8881L11.0348 81.1931L13.816 75.3486L7.35645 75.8881Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.67871 70.5834L7.35705 75.8884L10.1382 70.0439L3.67871 70.5834Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 65.3686L3.67834 70.6736L6.45952 64.8291L0 65.3686Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2583 165.533L72.58 160.229L69.7988 166.073L76.2583 165.533Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5796 160.229L68.9013 154.924L66.1201 160.768L72.5796 160.229Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9019 154.923L65.2236 149.618L62.4424 155.463L68.9019 154.923Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2232 149.618L61.5449 144.313L58.7637 150.158L65.2232 149.618Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5445 144.314L57.8661 139.009L55.085 144.853L61.5445 144.314Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8667 139.009L54.1884 133.704L51.4072 139.549L57.8667 139.009Z",
    fill: "#68A33D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.188 133.703L50.5097 128.398L47.7285 134.243L54.188 133.703Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5103 128.399L46.832 123.094L44.0508 128.938L50.5103 128.399Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8316 123.094L43.1533 117.789L40.3721 123.634L46.8316 123.094Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1529 117.788L39.4745 112.483L36.6934 118.328L43.1529 117.788Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4751 112.484L35.7968 107.179L33.0156 113.023L39.4751 112.484Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7964 107.179L32.1181 101.874L29.3369 107.718L35.7964 107.179Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2076 101.874L28.5292 96.5693L25.748 102.414L32.2076 101.874Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5298 96.5686L24.8515 91.2637L22.0703 97.1081L28.5298 96.5686Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4947 80.6536L13.8163 75.3486L11.0352 81.1931L17.4947 80.6536Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.816 75.3489L10.1376 70.0439L7.35645 75.8884L13.816 75.3489Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1382 70.0442L6.45989 64.7393L3.67871 70.5837L10.1382 70.0442Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45952 64.7395L2.78118 59.4346L0 65.279L6.45952 64.7395Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.12 160.768L69.7984 166.073L63.3389 166.612L66.12 160.768Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4423 155.463L66.1206 160.768L59.6611 161.307L62.4423 155.463Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7636 150.158L62.4419 155.463L55.9824 156.003L58.7636 150.158Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0849 144.854L58.7632 150.158L52.3037 150.698L55.0849 144.854Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4072 139.548L55.0855 144.853L48.626 145.392L51.4072 139.548Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7284 134.243L51.4068 139.548L44.9473 140.088L47.7284 134.243Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3395 166.612L59.6611 161.307L66.1206 160.768L63.3395 166.612Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6608 161.307L55.9824 156.002L62.4419 155.463L59.6608 161.307Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.982 156.093L52.3037 150.788L58.7632 150.248L55.982 156.093Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3043 150.788L48.626 145.483L55.0855 144.943L52.3043 150.788Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6256 145.482L44.9473 140.177L51.4068 139.638L48.6256 145.482Z",
    fill: "#2C4E27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 83.0986L104.697 83.1017V92.3389L104.692 92.3419L96.6094 87.7233V87.7172L104.691 83.0986Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 73.8545L104.697 73.8575V83.0948L104.692 83.0978L96.6094 78.4792V78.4731L104.691 73.8545Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 64.6113L104.697 64.6144V73.8516L104.692 73.8546L96.6094 69.236V69.2299L104.691 64.6113Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 55.3691L104.697 55.3722V64.6094L104.692 64.6125L96.6094 59.9938V59.9877L104.691 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 46.125L104.697 46.1281V55.3653L104.692 55.3683L96.6094 50.7497V50.7436L104.691 46.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.691 36.8828L104.697 36.8859V46.1231L104.692 46.1261L96.6094 41.5075V41.5014L104.691 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6094 87.7209V78.4775L104.697 83.0995L96.6094 87.7209Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6094 78.4757V69.2324L104.697 73.8544L96.6094 78.4757Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6094 69.2335V59.9902L104.697 64.6122L96.6094 69.2335Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6094 59.9904V50.7471L104.697 55.369L96.6094 59.9904Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6094 50.7472V41.5039L104.697 46.1259L96.6094 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 129.315L104.697 129.318V138.556L104.703 138.559L112.785 133.94V133.934L104.703 129.315Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 120.071L104.697 120.074V129.312L104.703 129.315L112.785 124.696V124.69L104.703 120.071Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 110.828L104.697 110.831V120.068L104.703 120.071L112.785 115.453V115.447L104.703 110.828Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 101.586L104.697 101.589V110.826L104.703 110.829L112.785 106.211V106.205L104.703 101.586Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 92.3418L104.697 92.3448V101.582L104.703 101.585L112.785 96.9665V96.9604L104.703 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 83.0986L104.697 83.1017V92.3389L104.703 92.3419L112.785 87.7233V87.7172L104.703 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 73.8545L104.697 73.8575V83.0948L104.703 83.0978L112.785 78.4792V78.4731L104.703 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 64.6113L104.697 64.6144V73.8516L104.703 73.8546L112.785 69.236V69.2299L104.703 64.6113Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 55.3691L104.697 55.3722V64.6094L104.703 64.6125L112.785 59.9938V59.9877L104.703 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 46.125L104.697 46.1281V55.3653L104.703 55.3683L112.785 50.7497V50.7436L104.703 46.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 36.8828L104.697 36.8859V46.1231L104.703 46.1261L112.785 41.5075V41.5014L104.703 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.703 27.6377L104.697 27.6407V36.878L104.703 36.881L112.785 32.2624V32.2563L104.703 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 143.18V133.937L104.697 138.558L112.785 143.18Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 133.938V124.694L104.697 129.316L112.785 133.938Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 124.694V115.45L104.697 120.072L112.785 124.694Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 115.45V106.207L104.697 110.829L112.785 115.45Z",
    fill: "#7FB941"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 106.206V96.9629L104.697 101.585L112.785 106.206Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 96.963V87.7197L104.697 92.3417L112.785 96.963Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 87.7209V78.4775L104.697 83.0995L112.785 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 78.4757V69.2324L104.697 73.8544L112.785 78.4757Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 69.2335V59.9902L104.697 64.6122L112.785 69.2335Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 59.9904V50.7471L104.697 55.369L112.785 59.9904Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 50.7472V41.5039L104.697 46.1259L112.785 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 41.5041V32.2607L104.697 36.8827L112.785 41.5041Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 32.2599V23.0166L104.697 27.6386L112.785 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 138.559L120.873 138.562V147.799L120.868 147.802L112.785 143.183V143.177L120.867 138.559Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 129.315L120.873 129.318V138.556L120.868 138.559L112.785 133.94V133.934L120.867 129.315Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 120.071L120.873 120.074V129.312L120.868 129.315L112.785 124.696V124.69L120.867 120.071Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 110.828L120.873 110.831V120.068L120.868 120.071L112.785 115.453V115.447L120.867 110.828Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 101.586L120.873 101.589V110.826L120.868 110.829L112.785 106.211V106.205L120.867 101.586Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 92.3418L120.873 92.3448V101.582L120.868 101.585L112.785 96.9665V96.9604L120.867 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 83.0986L120.873 83.1017V92.3389L120.868 92.3419L112.785 87.7233V87.7172L120.867 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 73.8545L120.873 73.8575V83.0948L120.868 83.0978L112.785 78.4792V78.4731L120.867 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 64.6113L120.873 64.6144V73.8516L120.868 73.8546L112.785 69.236V69.2299L120.867 64.6113Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 55.3691L120.873 55.3722V64.6094L120.868 64.6125L112.785 59.9938V59.9877L120.867 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 46.125L120.873 46.1281V55.3653L120.868 55.3683L112.785 50.7497V50.7436L120.867 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 36.8828L120.873 36.8859V46.1231L120.868 46.1261L112.785 41.5075V41.5014L120.867 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 27.6377L120.873 27.6407V36.878L120.868 36.881L112.785 32.2624V32.2563L120.867 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 18.3955L120.873 18.3986V27.6358L120.868 27.6388L112.785 23.0202V23.0141L120.867 18.3955Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.867 9.15234L120.873 9.15539V18.3926L120.868 18.3957L112.785 13.777V13.7709L120.867 9.15234Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 143.18V133.937L120.873 138.558L112.785 143.18Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 133.938V124.694L120.873 129.316L112.785 133.938Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 124.694V115.45L120.873 120.072L112.785 124.694Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 115.45V106.207L120.873 110.829L112.785 115.45Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 106.206V96.9629L120.873 101.585L112.785 106.206Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 96.963V87.7197L120.873 92.3417L112.785 96.963Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 87.7209V78.4775L120.873 83.0995L112.785 87.7209Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 78.4757V69.2324L120.873 73.8544L112.785 78.4757Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 69.2335V59.9902L120.873 64.6122L112.785 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 59.9904V50.7471L120.873 55.369L112.785 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 50.7472V41.5039L120.873 46.1259L112.785 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 41.5041V32.2607L120.873 36.8827L112.785 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 32.2599V23.0166L120.873 27.6386L112.785 32.2599Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.785 23.0167V13.7734L120.873 18.3954L112.785 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 138.559L120.873 138.562V147.799L120.879 147.802L128.961 143.183V143.177L120.879 138.559Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 129.315L120.873 129.318V138.556L120.879 138.559L128.961 133.94V133.934L120.879 129.315Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 120.071L120.873 120.074V129.312L120.879 129.315L128.961 124.696V124.69L120.879 120.071Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 110.828L120.873 110.831V120.068L120.879 120.071L128.961 115.453V115.447L120.879 110.828Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 101.586L120.873 101.589V110.826L120.879 110.829L128.961 106.211V106.205L120.879 101.586Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 92.3418L120.873 92.3448V101.582L120.879 101.585L128.961 96.9665V96.9604L120.879 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 83.0986L120.873 83.1017V92.3389L120.879 92.3419L128.961 87.7233V87.7172L120.879 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 73.8545L120.873 73.8575V83.0948L120.879 83.0978L128.961 78.4792V78.4731L120.879 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 64.6113L120.873 64.6144V73.8516L120.879 73.8546L128.961 69.236V69.2299L120.879 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 55.3691L120.873 55.3722V64.6094L120.879 64.6125L128.961 59.9938V59.9877L120.879 55.3691Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 46.125L120.873 46.1281V55.3653L120.879 55.3683L128.961 50.7497V50.7436L120.879 46.125Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 36.8828L120.873 36.8859V46.1231L120.879 46.1261L128.961 41.5075V41.5014L120.879 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 27.6377L120.873 27.6407V36.878L120.879 36.881L128.961 32.2624V32.2563L120.879 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.879 18.3955L120.873 18.3986V27.6358L120.879 27.6388L128.961 23.0202V23.0141L120.879 18.3955Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 143.18V133.937L120.873 138.558L128.961 143.18Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 133.938V124.694L120.873 129.316L128.961 133.938Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 124.694V115.45L120.873 120.072L128.961 124.694Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 115.45V106.207L120.873 110.829L128.961 115.45Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 106.206V96.9629L120.873 101.585L128.961 106.206Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 96.963V87.7197L120.873 92.3417L128.961 96.963Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 87.7209V78.4775L120.873 83.0995L128.961 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 78.4757V69.2324L120.873 73.8544L128.961 78.4757Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 69.2335V59.9902L120.873 64.6122L128.961 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 59.9904V50.7471L120.873 55.369L128.961 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 50.7472V41.5039L120.873 46.1259L128.961 50.7472Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 41.5041V32.2607L120.873 36.8827L128.961 41.5041Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 32.2599V23.0166L120.873 27.6386L128.961 32.2599Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 23.0167V13.7734L120.873 18.3954L128.961 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 129.315L137.049 129.318V138.556L137.043 138.559L128.961 133.94V133.934L137.043 129.315Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 120.071L137.049 120.074V129.312L137.043 129.315L128.961 124.696V124.69L137.043 120.071Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 110.828L137.049 110.831V120.068L137.043 120.071L128.961 115.453V115.447L137.043 110.828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 101.586L137.049 101.589V110.826L137.043 110.829L128.961 106.211V106.205L137.043 101.586Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 92.3418L137.049 92.3448V101.582L137.043 101.585L128.961 96.9665V96.9604L137.043 92.3418Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 83.0986L137.049 83.1017V92.3389L137.043 92.3419L128.961 87.7233V87.7172L137.043 83.0986Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 73.8545L137.049 73.8575V83.0948L137.043 83.0978L128.961 78.4792V78.4731L137.043 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 64.6113L137.049 64.6144V73.8516L137.043 73.8546L128.961 69.236V69.2299L137.043 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 55.3691L137.049 55.3722V64.6094L137.043 64.6125L128.961 59.9938V59.9877L137.043 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 46.125L137.049 46.1281V55.3653L137.043 55.3683L128.961 50.7497V50.7436L137.043 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 36.8828L137.049 36.8859V46.1231L137.043 46.1261L128.961 41.5075V41.5014L137.043 36.8828Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 27.6377L137.049 27.6407V36.878L137.043 36.881L128.961 32.2624V32.2563L137.043 27.6377Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 18.3955L137.049 18.3986V27.6358L137.043 27.6388L128.961 23.0202V23.0141L137.043 18.3955Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.043 9.15234L137.049 9.15539V18.3926L137.043 18.3957L128.961 13.777V13.7709L137.043 9.15234Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 143.18V133.937L137.049 138.558L128.961 143.18Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 133.938V124.694L137.049 129.316L128.961 133.938Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 124.694V115.45L137.049 120.072L128.961 124.694Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 115.45V106.207L137.049 110.829L128.961 115.45Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 106.206V96.9629L137.049 101.585L128.961 106.206Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 96.963V87.7197L137.049 92.3417L128.961 96.963Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 87.7209V78.4775L137.049 83.0995L128.961 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 78.4757V69.2324L137.049 73.8544L128.961 78.4757Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 69.2335V59.9902L137.049 64.6122L128.961 69.2335Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 59.9904V50.7471L137.049 55.369L128.961 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 50.7472V41.5039L137.049 46.1259L128.961 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 41.5041V32.2607L137.049 36.8827L128.961 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 32.2599V23.0166L137.049 27.6386L128.961 32.2599Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 23.0167V13.7734L137.049 18.3954L128.961 23.0167Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.961 13.7726V4.5293L137.049 9.15126L128.961 13.7726Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 129.315L137.049 129.318V138.556L137.054 138.559L145.137 133.94V133.934L137.055 129.315Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 120.071L137.049 120.074V129.312L137.054 129.315L145.137 124.696V124.69L137.055 120.071Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 110.828L137.049 110.831V120.068L137.054 120.071L145.137 115.453V115.447L137.055 110.828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 101.586L137.049 101.589V110.826L137.054 110.829L145.137 106.211V106.205L137.055 101.586Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 92.3418L137.049 92.3448V101.582L137.054 101.585L145.137 96.9665V96.9604L137.055 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 83.0986L137.049 83.1017V92.3389L137.054 92.3419L145.137 87.7233V87.7172L137.055 83.0986Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 73.8545L137.049 73.8575V83.0948L137.054 83.0978L145.137 78.4792V78.4731L137.055 73.8545Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 64.6113L137.049 64.6144V73.8516L137.054 73.8546L145.137 69.236V69.2299L137.055 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 55.3691L137.049 55.3722V64.6094L137.054 64.6125L145.137 59.9938V59.9877L137.055 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 46.125L137.049 46.1281V55.3653L137.054 55.3683L145.137 50.7497V50.7436L137.055 46.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 36.8828L137.049 36.8859V46.1231L137.054 46.1261L145.137 41.5075V41.5014L137.055 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 27.6377L137.049 27.6407V36.878L137.054 36.881L145.137 32.2624V32.2563L137.055 27.6377Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 18.3955L137.049 18.3986V27.6358L137.054 27.6388L145.137 23.0202V23.0141L137.055 18.3955Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 9.15234L137.049 9.15539V18.3926L137.054 18.3957L145.137 13.777V13.7709L137.055 9.15234Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.055 -0.0917969L137.049 -0.0887467V9.14847L137.054 9.15152L145.137 4.53291V4.52681L137.055 -0.0917969Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 133.938V124.694L137.049 129.316L145.137 133.938Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 124.694V115.45L137.049 120.072L145.137 124.694Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 115.45V106.207L137.049 110.829L145.137 115.45Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 106.206V96.9629L137.049 101.585L145.137 106.206Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 96.963V87.7197L137.049 92.3417L145.137 96.963Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 87.7209V78.4775L137.049 83.0995L145.137 87.7209Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 78.4757V69.2324L137.049 73.8544L145.137 78.4757Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 69.2335V59.9902L137.049 64.6122L145.137 69.2335Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 59.9904V50.7471L137.049 55.369L145.137 59.9904Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 50.7472V41.5039L137.049 46.1259L145.137 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 41.5041V32.2607L137.049 36.8827L145.137 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 32.2599V23.0166L137.049 27.6386L145.137 32.2599Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 23.0167V13.7734L137.049 18.3954L145.137 23.0167Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 13.7726V4.5293L137.049 9.15126L145.137 13.7726Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 4.53042V-4.71289L137.049 -0.0909295L145.137 4.53042Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 120.071L153.225 120.074V129.312L153.219 129.315L145.137 124.696V124.69L153.218 120.071Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 110.828L153.225 110.831V120.068L153.219 120.071L145.137 115.453V115.447L153.218 110.828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 101.586L153.225 101.589V110.826L153.219 110.829L145.137 106.211V106.205L153.218 101.586Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 92.3418L153.225 92.3448V101.582L153.219 101.585L145.137 96.9665V96.9604L153.218 92.3418Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 83.0986L153.225 83.1017V92.3389L153.219 92.3419L145.137 87.7233V87.7172L153.218 83.0986Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 73.8545L153.225 73.8575V83.0948L153.219 83.0978L145.137 78.4792V78.4731L153.218 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 64.6113L153.225 64.6144V73.8516L153.219 73.8546L145.137 69.236V69.2299L153.218 64.6113Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 55.3691L153.225 55.3722V64.6094L153.219 64.6125L145.137 59.9938V59.9877L153.218 55.3691Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 46.125L153.225 46.1281V55.3653L153.219 55.3683L145.137 50.7497V50.7436L153.218 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 36.8828L153.225 36.8859V46.1231L153.219 46.1261L145.137 41.5075V41.5014L153.218 36.8828Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 27.6377L153.225 27.6407V36.878L153.219 36.881L145.137 32.2624V32.2563L153.218 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.218 18.3955L153.225 18.3986V27.6358L153.219 27.6388L145.137 23.0202V23.0141L153.218 18.3955Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 133.938V124.694L153.225 129.316L145.137 133.938Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 124.694V115.45L153.225 120.072L145.137 124.694Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 115.45V106.207L153.225 110.829L145.137 115.45Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 106.206V96.9629L153.225 101.585L145.137 106.206Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 96.963V87.7197L153.225 92.3417L145.137 96.963Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 87.7209V78.4775L153.225 83.0995L145.137 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 78.4757V69.2324L153.225 73.8544L145.137 78.4757Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 69.2335V59.9902L153.225 64.6122L145.137 69.2335Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 59.9904V50.7471L153.225 55.369L145.137 59.9904Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 50.7472V41.5039L153.225 46.1259L145.137 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 41.5041V32.2607L153.225 36.8827L145.137 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 32.2599V23.0166L153.225 27.6386L145.137 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.137 23.0167V13.7734L153.225 18.3954L145.137 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 120.071L153.225 120.074V129.312L153.23 129.315L161.313 124.696V124.69L153.231 120.071Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 110.828L153.225 110.831V120.068L153.23 120.071L161.313 115.453V115.447L153.231 110.828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 101.586L153.225 101.589V110.826L153.23 110.829L161.313 106.211V106.205L153.231 101.586Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 92.3418L153.225 92.3448V101.582L153.23 101.585L161.313 96.9665V96.9604L153.231 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 83.0986L153.225 83.1017V92.3389L153.23 92.3419L161.313 87.7233V87.7172L153.231 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 73.8545L153.225 73.8575V83.0948L153.23 83.0978L161.313 78.4792V78.4731L153.231 73.8545Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 64.6113L153.225 64.6144V73.8516L153.23 73.8546L161.313 69.236V69.2299L153.231 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 55.3691L153.225 55.3722V64.6094L153.23 64.6125L161.313 59.9938V59.9877L153.231 55.3691Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 46.125L153.225 46.1281V55.3653L153.23 55.3683L161.313 50.7497V50.7436L153.231 46.125Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 36.8828L153.225 36.8859V46.1231L153.23 46.1261L161.313 41.5075V41.5014L153.231 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 27.6377L153.225 27.6407V36.878L153.23 36.881L161.313 32.2624V32.2563L153.231 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 18.3955L153.225 18.3986V27.6358L153.23 27.6388L161.313 23.0202V23.0141L153.231 18.3955Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.231 9.15234L153.225 9.15539V18.3926L153.23 18.3957L161.313 13.777V13.7709L153.231 9.15234Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 124.694V115.45L153.225 120.072L161.313 124.694Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 115.45V106.207L153.225 110.829L161.313 115.45Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 106.206V96.9629L153.225 101.585L161.313 106.206Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 96.963V87.7197L153.225 92.3417L161.313 96.963Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 87.7209V78.4775L153.225 83.0995L161.313 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 78.4757V69.2324L153.225 73.8544L161.313 78.4757Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 69.2335V59.9902L153.225 64.6122L161.313 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 59.9904V50.7471L153.225 55.369L161.313 59.9904Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 50.7472V41.5039L153.225 46.1259L161.313 50.7472Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 41.5041V32.2607L153.225 36.8827L161.313 41.5041Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 32.2599V23.0166L153.225 27.6386L161.313 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 23.0167V13.7734L153.225 18.3954L161.313 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.313 13.7726V4.5293L153.225 9.15126L161.313 13.7726Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 101.586L169.4 101.589V110.826L169.395 110.829L161.312 106.211V106.205L169.394 101.586Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 92.3418L169.4 92.3448V101.582L169.395 101.585L161.312 96.9665V96.9604L169.394 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 83.0986L169.4 83.1017V92.3389L169.395 92.3419L161.312 87.7233V87.7172L169.394 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 73.8545L169.4 73.8575V83.0948L169.395 83.0978L161.312 78.4792V78.4731L169.394 73.8545Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 64.6113L169.4 64.6144V73.8516L169.395 73.8546L161.312 69.236V69.2299L169.394 64.6113Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 55.3691L169.4 55.3722V64.6094L169.395 64.6125L161.312 59.9938V59.9877L169.394 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 46.125L169.4 46.1281V55.3653L169.395 55.3683L161.312 50.7497V50.7436L169.394 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 36.8828L169.4 36.8859V46.1231L169.395 46.1261L161.312 41.5075V41.5014L169.394 36.8828Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.394 27.6377L169.4 27.6407V36.878L169.395 36.881L161.312 32.2624V32.2563L169.394 27.6377Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 115.45V106.207L169.4 110.829L161.312 115.45Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 106.206V96.9629L169.4 101.585L161.312 106.206Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 96.963V87.7197L169.4 92.3417L161.312 96.963Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 87.7209V78.4775L169.4 83.0995L161.312 87.7209Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 78.4757V69.2324L169.4 73.8544L161.312 78.4757Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 69.2335V59.9902L169.4 64.6122L161.312 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 59.9904V50.7471L169.4 55.369L161.312 59.9904Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 50.7472V41.5039L169.4 46.1259L161.312 50.7472Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 41.5041V32.2607L169.4 36.8827L161.312 41.5041Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 23.0167V13.7734L169.4 18.3954L161.312 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.312 13.7726V4.5293L169.4 9.15126L161.312 13.7726Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 101.586L169.4 101.589V110.826L169.406 110.829L177.488 106.211V106.205L169.407 101.586Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 92.3418L169.4 92.3448V101.582L169.406 101.585L177.488 96.9665V96.9604L169.407 92.3418Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 83.0986L169.4 83.1017V92.3389L169.406 92.3419L177.488 87.7233V87.7172L169.407 83.0986Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 73.8545L169.4 73.8575V83.0948L169.406 83.0978L177.488 78.4792V78.4731L169.407 73.8545Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 64.6113L169.4 64.6144V73.8516L169.406 73.8546L177.488 69.236V69.2299L169.407 64.6113Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 55.3691L169.4 55.3722V64.6094L169.406 64.6125L177.488 59.9938V59.9877L169.407 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 46.125L169.4 46.1281V55.3653L169.406 55.3683L177.488 50.7497V50.7436L169.407 46.125Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 36.8828L169.4 36.8859V46.1231L169.406 46.1261L177.488 41.5075V41.5014L169.407 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.407 27.6377L169.4 27.6407V36.878L169.406 36.881L177.488 32.2624V32.2563L169.407 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 106.206V96.9629L169.4 101.585L177.488 106.206Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 96.963V87.7197L169.4 92.3417L177.488 96.963Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 87.7209V78.4775L169.4 83.0995L177.488 87.7209Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 78.4757V69.2324L169.4 73.8544L177.488 78.4757Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 69.2335V59.9902L169.4 64.6122L177.488 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 59.9904V50.7471L169.4 55.369L177.488 59.9904Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 50.7472V41.5039L169.4 46.1259L177.488 50.7472Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 41.5041V32.2607L169.4 36.8827L177.488 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 32.2599V23.0166L169.4 27.6386L177.488 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 92.3418L185.576 92.3448V101.582L185.571 101.585L177.488 96.9665V96.9604L185.57 92.3418Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 83.0986L185.576 83.1017V92.3389L185.571 92.3419L177.488 87.7233V87.7172L185.57 83.0986Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 73.8545L185.576 73.8575V83.0948L185.571 83.0978L177.488 78.4792V78.4731L185.57 73.8545Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 64.6113L185.576 64.6144V73.8516L185.571 73.8546L177.488 69.236V69.2299L185.57 64.6113Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 55.3691L185.576 55.3722V64.6094L185.571 64.6125L177.488 59.9938V59.9877L185.57 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 46.125L185.576 46.1281V55.3653L185.571 55.3683L177.488 50.7497V50.7436L185.57 46.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 36.8828L185.576 36.8859V46.1231L185.571 46.1261L177.488 41.5075V41.5014L185.57 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 27.6377L185.576 27.6407V36.878L185.571 36.881L177.488 32.2624V32.2563L185.57 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 18.3955L185.576 18.3986V27.6358L185.571 27.6388L177.488 23.0202V23.0141L185.57 18.3955Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 106.206V96.9629L185.576 101.585L177.488 106.206Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 96.963V87.7197L185.576 92.3417L177.488 96.963Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 87.7209V78.4775L185.576 83.0995L177.488 87.7209Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 78.4757V69.2324L185.576 73.8544L177.488 78.4757Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 69.2335V59.9902L185.576 64.6122L177.488 69.2335Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 59.9904V50.7471L185.576 55.369L177.488 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 50.7472V41.5039L185.576 46.1259L177.488 50.7472Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 41.5041V32.2607L185.576 36.8827L177.488 41.5041Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 32.2599V23.0166L185.576 27.6386L177.488 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.488 23.0167V13.7734L185.576 18.3954L177.488 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 92.3418L185.576 92.3448V101.582L185.582 101.585L193.664 96.9665V96.9604L185.582 92.3418Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 83.0986L185.576 83.1017V92.3389L185.582 92.3419L193.664 87.7233V87.7172L185.582 83.0986Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 73.8545L185.576 73.8575V83.0948L185.582 83.0978L193.664 78.4792V78.4731L185.582 73.8545Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 64.6113L185.576 64.6144V73.8516L185.582 73.8546L193.664 69.236V69.2299L185.582 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 55.3691L185.576 55.3722V64.6094L185.582 64.6125L193.664 59.9938V59.9877L185.582 55.3691Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 46.125L185.576 46.1281V55.3653L185.582 55.3683L193.664 50.7497V50.7436L185.582 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 36.8828L185.576 36.8859V46.1231L185.582 46.1261L193.664 41.5075V41.5014L185.582 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 27.6377L185.576 27.6407V36.878L185.582 36.881L193.664 32.2624V32.2563L185.582 27.6377Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 18.3955L185.576 18.3986V27.6358L185.582 27.6388L193.664 23.0202V23.0141L185.582 18.3955Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 96.963V87.7197L185.576 92.3417L193.664 96.963Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 87.7209V78.4775L185.576 83.0995L193.664 87.7209Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 78.4757V69.2324L185.576 73.8544L193.664 78.4757Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 69.2335V59.9902L185.576 64.6122L193.664 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 59.9904V50.7471L185.576 55.369L193.664 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 50.7472V41.5039L185.576 46.1259L193.664 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 41.5041V32.2607L185.576 36.8827L193.664 41.5041Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 32.2599V23.0166L185.576 27.6386L193.664 32.2599Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 23.0167V13.7734L185.576 18.3954L193.664 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.746 64.6113L201.752 64.6144V73.8516L201.746 73.8546L193.664 69.236V69.2299L201.746 64.6113Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.746 55.3691L201.752 55.3722V64.6094L201.746 64.6125L193.664 59.9938V59.9877L201.746 55.3691Z",
    fill: "#DBF1C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.746 46.125L201.752 46.1281V55.3653L201.746 55.3683L193.664 50.7497V50.7436L201.746 46.125Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.746 36.8828L201.752 36.8859V46.1231L201.746 46.1261L193.664 41.5075V41.5014L201.746 36.8828Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 87.7209V78.4775L201.752 83.0995L193.664 87.7209Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 78.4757V69.2324L201.752 73.8544L193.664 78.4757Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 69.2335V59.9902L201.752 64.6122L193.664 69.2335Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 59.9904V50.7471L201.752 55.369L193.664 59.9904Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 50.7472V41.5039L201.752 46.1259L193.664 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 41.5041V32.2607L201.752 36.8827L193.664 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 32.2599V23.0166L201.752 27.6386L193.664 32.2599Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.664 23.0167V13.7734L201.752 18.3954L193.664 23.0167Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.758 64.6113L201.752 64.6144V73.8516L201.757 73.8546L209.84 69.236V69.2299L201.758 64.6113Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.758 55.3691L201.752 55.3722V64.6094L201.757 64.6125L209.84 59.9938V59.9877L201.758 55.3691Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.758 46.125L201.752 46.1281V55.3653L201.757 55.3683L209.84 50.7497V50.7436L201.758 46.125Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.758 36.8828L201.752 36.8859V46.1231L201.757 46.1261L209.84 41.5075V41.5014L201.758 36.8828Z",
    fill: "#1F4F22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.84 59.9904V50.7471L201.752 55.369L209.84 59.9904Z",
    fill: "#53A626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.84 50.7472V41.5039L201.752 46.1259L209.84 50.7472Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.84 41.5041V32.2607L201.752 36.8827L209.84 41.5041Z",
    fill: "#B2D530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2781 220.831L41.8076 214.717L53.3809 206.984L54.2781 220.831Z",
    fill: "#3B6250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7945 228.564L41.8076 214.717L54.2781 220.831L42.7945 228.564Z",
    fill: "#6D8F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.278 220.831L65.8513 213.099H65.7616L53.3809 206.895V206.984L54.278 220.831Z",
    fill: "#6D8F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8643 199.161L53.291 206.804L65.7615 213.008L64.8643 199.161Z",
    fill: "#3B6250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3347 205.276L64.8643 199.161L76.3478 191.429L77.3347 205.276Z",
    fill: "#3B6250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8643 199.161L77.3347 205.365L65.7614 213.008L64.8643 199.161Z",
    fill: "#6D8F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3347 205.365L88.908 197.633L76.4375 191.429L77.3347 205.365Z",
    fill: "#6D8F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.921 183.696L76.3477 191.429L88.8181 197.543L87.921 183.696Z",
    fill: "#3B6250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.392 189.81L87.9219 183.696V183.606L99.4055 175.873L100.392 189.81Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9219 183.696L100.392 189.81L88.819 197.543L87.9219 183.696Z",
    fill: "#6D8F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.392 189.81L111.876 181.987L99.4053 175.873L100.392 189.81Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.979 168.141L99.4053 175.873L111.876 181.987L110.979 168.141Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.875 181.987L100.392 189.81L112.862 195.924L111.875 181.987Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.462 160.408L123.449 174.255H123.359L110.979 168.141L122.462 160.318V160.408Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.345 188.102L111.875 181.988L123.359 174.255H123.448L124.345 188.102Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.979 168.141L123.359 174.255L111.876 181.987L110.979 168.141Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.875 181.987L124.345 188.102L112.862 195.924L111.875 181.987Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.932 166.433L133.946 152.586L122.462 160.319L134.932 166.433Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.462 160.408L123.359 174.255H123.449L134.932 166.522V166.433L122.462 160.318V160.408Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.346 188.102L135.83 180.369L123.449 174.255H123.359L124.346 188.102Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.933 166.522L123.359 174.255L135.83 180.369L134.933 166.522Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.416 158.699L133.945 152.585L145.519 144.853L146.416 158.699Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.932 166.433L133.945 152.586L146.416 158.7L134.932 166.433Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.416 158.7L147.403 172.637L134.933 166.523V166.433L146.416 158.7Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.933 166.522L147.403 172.637L135.83 180.369L134.933 166.522Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.416 158.699L157.989 150.967L145.519 144.853L146.416 158.699Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.886 164.814L157.989 150.967L146.416 158.699L158.886 164.814Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.416 158.7L147.403 172.637L158.886 164.814L146.416 158.7Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.002 137.12L145.519 144.853L157.989 150.967L157.002 137.12Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46 157.081L157.989 150.967L169.473 143.234L170.46 157.081Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.886 164.814L157.989 150.967L170.46 157.081L158.886 164.814Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.002 137.12L169.472 143.234L157.989 150.967L157.002 137.12Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.575 129.298L169.472 143.145V143.235L157.002 137.12V137.031L168.486 129.298H168.575Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46 157.081L181.943 149.349L169.473 143.234L170.46 157.081Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.956 135.412L169.473 143.235L181.943 149.349L180.956 135.412Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.956 135.412L180.059 121.565L168.575 129.298L180.956 135.412Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.486 129.298L169.473 143.145V143.235L180.957 135.412L168.576 129.298H168.486Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.956 135.412L193.427 141.526L181.943 149.349L180.956 135.412Z",
    fill: "#8A898E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53 127.679L180.06 121.565L191.543 113.742L192.53 127.679Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.957 135.412L180.06 121.565L192.53 127.68L180.957 135.412Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.529 127.68L193.427 141.527L180.956 135.412L192.529 127.68Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.116 106.01L191.543 113.742L204.013 119.857L203.116 106.01Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.53 127.679L204.013 119.946V119.856L191.543 113.742L192.53 127.679Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 133.793L204.013 119.946L192.529 127.679L205 133.793Z",
    fill: "#E5E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.529 127.68L193.426 141.527L205 133.794L192.529 127.68Z",
    fill: "#8A898E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1701_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 228.563,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelChoppingSalad);
export default __webpack_public_path__ + "static/media/pixel-chopping-salad.7979b909c34e276af0a7f894347cb6c2.svg";
export { ForwardRef as ReactComponent };